import Swiper, { Controller, Keyboard, Manipulation } from 'swiper'

export default class SingleCarCoverSlider {
  constructor() {
    this.thumbs = new Swiper('.thumb-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      threshold: 20,
      loop: true,
      slideToClickedSlide: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      modules: [Controller, Keyboard, Manipulation]
    })

    this.slider = new Swiper('.main-swiper', {
      slidesPerView: 1,
      threshold: 20,
      centeredSlides: true,
      loop: true,
      loopedSlides: this.thumbs.activeIndex,
      spaceBetween: 24,
      modules: [Controller, Manipulation]
    })

    this.slider.controller.control = this.thumbs
    this.thumbs.controller.control = this.slider

    this.createPhyron()
    this.handleVideoSize()

    window.addEventListener('resize', () => {
      this.handleVideoSize()
    })
  }

  createPhyron () {
    const showPhyronVideos = document.querySelector('.mtt-single-car-cover')?.getAttribute('data-show-phyron')
    const id = document.querySelector('.mtt-single-car-cover')?.getAttribute('data-id')
    const swiper = document.querySelector('.mtt-single-car-cover .main-swiper')

    if (showPhyronVideos === 'false' || showPhyronVideos == null || id.length <= 0 || swiper == null) {
      return
    }
    const videoTag = `
       <div class="swiper-slide object-fit video-tag">
          <div style="display: none">
            <video
                class="phyron-video"
                data-campaign="nellemann"
                data-product-key="${id}"
                data-file="1024x768"
                data-tracking-source="phyron"
                data-callback="phyronCallback"           
            </video>
          </div>
      </div>
    `

    const thumbTag = `
      <div class="swiper-slide video-thumb">
        <div class="object-fit">
          <img src="" alt="">
        </div>
      </div>
    `
    this.slider.prependSlide(videoTag)
    this.thumbs.prependSlide(thumbTag)
    this.slider.slideToLoop(0)
    this.thumbs.slideToLoop(0)
  }

  handleVideoSize () {
    const iframes = document.querySelectorAll('.swiper-slide iframe')

    if (iframes.length <= 0) {
      return
    }

    iframes.forEach(iframe => {
      const parent = iframe.parentNode

      const height = parent.clientHeight
      iframe.style.height = `${height}px`
      iframe.style.width = `100%`
    })
  }
}
